var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"org-machine-list"},[_c('h2',{staticClass:"title"},[_vm._v("机床管理系统")]),_c('div',{staticClass:"tree-container"},_vm._l((_vm.organizations),function(org){return _c('tree-node',{key:org.id,attrs:{"org":org}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }